export default {
  data() {
    return {
      loadingCurrency: false,
      currency: {
        value: 1,
        prefix: "R$",
        code: "BRL",
      },
    };
  },
  computed: {
    foreignPrice: function () {
      if (window.plan) {
        const planPrice = this.getPriceForCurrency(window.plan);
        if (planPrice) return planPrice;
      }

      if (window.offer) {
        const offerPrice = this.getPriceForCurrency(window.offer);
        if (offerPrice) return offerPrice;
      }
      if (window.lot) {
        const lotPrice = this.getPriceForCurrency(window.lot);
        if (lotPrice) return lotPrice;
      }

      if (window.product) {
        const productPrice = this.getPriceForCurrency(window.product);
        if (productPrice) return productPrice;
      }

      return null;
    },
  },
  methods: {
    getPriceForCurrency(item) {
      if (this.currency.code === "USD" && item.price_usd) {
        return item.price_usd;
      }
      if (this.currency.code === "EUR" && item.price_eur) {
        return item.price_eur;
      }
      return null;
    },
    setDefaultCurrency() {
      this.currency = {
        value: 1,
        prefix: "R$",
        code: "BRL",
      };
    },
    getCurrency(country) {
      if (country.toLowerCase() === "br") {
        this.setDefaultCurrency();
        return;
      }
      this.loadingCurrency = true;

      $.ajax({
        url: window.apiUrl + "/v1/countries/exchange/" + country,
        dataType: "json",
      })
        .done((responseData) => {
          var data = Object.values(responseData)[0];
          if (!data || !data.codein) {
            this.setDefaultCurrency();
            return;
          }
          this.currency = {
            value: data.high,
            code: data.codein,
            prefix:
              {
                USD: "$",
                EUR: "€",
                GBP: "£",
                JPY: "¥",
              }[data.codein] || data.codein,
          };
        })
        .fail(() => {
          this.setDefaultCurrency();
        })
        .always(() => {
          this.loadingCurrency = false;
        });
    },
  },
};
